module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/vendor-facets-79abee85346c4663172b502143223fa4.png";